import React, { useCallback, useContext } from 'react';

import { EditorContext } from './../../../ricos-context';
import type { RicosPluginAddButton, RicosPluginAddButtons } from './../../../ricos-plugins';

import InsertPluginToolbar from '../../components/InsertPluginToolbar/InsertPluginToolbar';
import { ADD_PLUGIN_MENU, ADD_PLUGIN_MENU_HORIZONTAL } from './data-hooks';
import styles from './styles/floating-add-plugin-menu.rtlignore-scss';

interface Props {
  referenceElement?: React.RefObject<HTMLElement>;
  buttons: RicosPluginAddButtons;
}

const AddPluginMenuHorizontal: React.FC<Props> = ({ referenceElement, buttons }) => {
  const { getPublicCommands } = useContext(EditorContext);

  const onButtonClick = useCallback(
    (addButton: RicosPluginAddButton) => {
      const menuItem = addButton.toHorizontalMenuItem();
      return menuItem.getClickHandler(getPublicCommands?.(), referenceElement?.current)();
    },
    [referenceElement, getPublicCommands]
  );

  return (
    <div
      className={styles.addPluginMenu_horizontal_wrapper}
      data-hook={`${ADD_PLUGIN_MENU_HORIZONTAL} ${ADD_PLUGIN_MENU}`}
    >
      <InsertPluginToolbar type="regular" buttons={buttons} onButtonClick={onButtonClick} />
    </div>
  );
};

export default AddPluginMenuHorizontal;
